import recoverHardRefresh from './hardRefresh'

export default function register() {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    console.log("Registering service worker")
    // Recover service worker if there was a hard refresh
    navigator.serviceWorker.getRegistration().then(recoverHardRefresh)

    window.addEventListener('load', () => {
      const swUrl = `${import.meta.env.BASE_URL}service-worker.js`
      navigator.serviceWorker
        .register(swUrl)
        .catch((error) => {
          console.error('Error during service worker registration:', error)
        })
    }
    )
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
